import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const CodeBlock = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 16 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 3.5H4C3.44772 3.5 3 3.94772 3 4.5V12.5C3 13.0523 3.44772 13.5 4 13.5H12C12.5523 13.5 13 13.0523 13 12.5V4.5C13 3.94772 12.5523 3.5 12 3.5ZM4 2.5C2.89543 2.5 2 3.39543 2 4.5V12.5C2 13.6046 2.89543 14.5 4 14.5H12C13.1046 14.5 14 13.6046 14 12.5V4.5C14 3.39543 13.1046 2.5 12 2.5H4ZM4.63523 5.65803C4.8241 5.45657 5.14051 5.44637 5.34197 5.63523L8.00864 8.13523C8.10946 8.22976 8.16667 8.3618 8.16667 8.5C8.16667 8.6382 8.10946 8.77024 8.00864 8.86477L5.34197 11.3648C5.14051 11.5536 4.8241 11.5434 4.63523 11.342C4.44637 11.1405 4.45657 10.8241 4.65803 10.6352L6.93561 8.5L4.65803 6.36477C4.45657 6.1759 4.44637 5.85949 4.63523 5.65803ZM8.5 10.5C8.22386 10.5 8 10.7239 8 11C8 11.2761 8.22386 11.5 8.5 11.5H11C11.2761 11.5 11.5 11.2761 11.5 11C11.5 10.7239 11.2761 10.5 11 10.5H8.5Z"
        fill={color}
      />
    </svg>
  )
})

export default CodeBlock
